import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { NavParams, PopoverController, ViewController } from "ionic-angular";
import SelectFormInput from "../../../models/SelectFormInput";
import { OrderPopupComponent } from "../order-popup/order-popup";

@Component({
  selector: "order-container",
  templateUrl: "order-container.html",
})
export class OrderContainerComponent implements OnInit {
  @Input() config: string;
  @Input() orderItems: any[];
  @Input() orderID: any;
  @Input() type: string;
  @Input() orderTypeEnums: SelectFormInput[] = [];
  @Input() categoryEnums: SelectFormInput[] = [];
  @Input() diagnosisEnums: any = [];
  @Input() roleEnums: SelectFormInput[] = [];
  @Input() isAudit: boolean = false;
  @Input() reasonForGIPOptions: Object;
  @Input() symptoms: Object;
  @Output() itemButtonPress: EventEmitter<any> = new EventEmitter();
  openStatus = false;
  sortByType = false;
  selectAllSubOrders: boolean = false;
  orderSelection: boolean = false;

  ngOnInit(): void {
    switch (this.config) {
      case "new":
        this.openStatus = true;
        break;
      case "open":
        break;
      case "panel":
        this.openStatus = true;
        break;
      case "panel-audit":
        this.openStatus = true;
        break;
      case "active":
        this.sortByType = true;
        break;
      default:
        break;
    }
  }

  constructor(
    public popover: PopoverController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private cdRef: ChangeDetectorRef
  ) {}

  openOptionPopup(event) {
    let printModal = this.popover.create(
      OrderPopupComponent,
      { config: { orderStatus: "open" } },
      { cssClass: "open-orders-popover" }
    );

    printModal.onDidDismiss((data) => {
      if (data) {
        let payload = data;
        payload.id = this.orderID;
        payload.isDiscontinueOrder = this.config === "disc";
        this.buttonPressReceived(payload, -1);
      }
    });

    //Change Popup Location
    let ev = {
      target: {
        getBoundingClientRect: () => {
          return {
            top: event.y + 20,
            left: event.x - 75,
          };
        },
      },
    };
    //popup spawn location needs adjustment unless on iPad
    if (window.navigator.userAgent.indexOf("iPad") != -1) {
      printModal.present({ ev: event });
    } else {
      printModal.present({ ev: ev });
    }
  }

  openOptionPopup1(event) {
    let printModal = this.popover.create(
      OrderPopupComponent,
      { config: { orderStatus: "active-parent" } },
      { cssClass: "open-orders-popover" }
    );

    printModal.onDidDismiss((data) => {
      if (data) {
        let payload = data;
        payload.id = this.orderID;
        //payload.isDiscontinueOrder = (this.config==='disc');
        this.buttonPressReceived(payload, -1);
      }
    });

    //Change Popup Location
    let ev = {
      target: {
        getBoundingClientRect: () => {
          return {
            top: event.y + 20,
            left: event.x - 75,
          };
        },
      },
    };
    //popup spawn location needs adjustment unless on iPad
    if (window.navigator.userAgent.indexOf("iPad") != -1) {
      printModal.present({ ev: event });
    } else {
      printModal.present({ ev: ev });
    }
  }

  buttonPressReceived(payload: any, index: number) {
    payload.index = index;
    payload.type = this.type;
    this.itemButtonPress.emit(payload);
  }

  displayType(): string {
    if (this.orderTypeEnums.length > 0) {
      let typeEnum = this.orderTypeEnums.find((type) => {
        return type.value === this.type;
      });

      if (typeEnum) {
        return typeEnum.display;
      }
    }

    return "";
  }

  selectAll() {
    this.selectAllSubOrders = !this.selectAllSubOrders;
    this.orderItems.map((orderItem) => {
      orderItem.isSubOrderChecked = this.selectAllSubOrders;
    });
  }

  onSubOrderSelection(event, index, orderItems) {
    orderItems[index]["isSubOrderChecked"] = event;
    this.orderSelection = orderItems.every((x) => x.isSubOrderChecked === true);
    this.selectAllSubOrders = this.orderSelection;
    this.cdRef.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/order-container/order-container.ts